import moment from 'moment';
import * as fabric from 'office-ui-fabric-react';
import React, { FC, useEffect, useState } from 'react';

interface ShowRegistrationTicketProps {
    serviceNumber: string | null;
    serviceName: string | null;
    registrationTime: moment.Moment;
}

export const ShowRegistrationTicketModal: FC<ShowRegistrationTicketProps> = (props: ShowRegistrationTicketProps) => {
    const [showHide, setShowHide] = useState(false);

    useEffect(() => {
        resolveModal();
    }, []);

    const resolveModal = () => {
        if (props) {
            setShowHide(true);
        }
    };

    return (
        <fabric.Modal
            isOpen={showHide}
            isModeless={true}
            styles={{
                root: {
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    flexFlow: 'column nowrap',
                    alignItems: 'center',
                    justifyContent: 'center'
                }
            }}
        >
            <fabric.Stack.Item align="center" styles={{ root: { margin: '3vw' } }}>
                <fabric.Stack horizontalAlign="center">
                    <fabric.Text variant="xLarge">Jūsų bilietas</fabric.Text>
                </fabric.Stack>

                <fabric.Stack horizontalAlign="center" styles={{ root: { margin: '3vw' } }}>
                    <fabric.Text>{props.serviceName}</fabric.Text>
                </fabric.Stack>
                <fabric.Stack horizontalAlign="center" styles={{ root: { margin: '3vw' } }}>
                    <fabric.Text>{props.serviceNumber}</fabric.Text>
                </fabric.Stack>
                <fabric.Stack horizontalAlign="center" styles={{ root: { margin: '3vw' } }}>
                    <fabric.Text>{props.registrationTime.local().format('YYYY-MM-DD HH:ss')}</fabric.Text>
                </fabric.Stack>
            </fabric.Stack.Item>
        </fabric.Modal>
    );
};
